export var AegisEnv;
(function (AegisEnv) {
  AegisEnv["PROD"] = "production";
  AegisEnv["PRE"] = "pre";
  AegisEnv["TEST"] = "test";
  AegisEnv["DEV"] = "development";
  AegisEnv["GRAY"] = "gray";
})(AegisEnv || (AegisEnv = {}));
export var ReportErrorLevel;
(function (ReportErrorLevel) {
  ReportErrorLevel["NOTICE"] = "notice";
  ReportErrorLevel["SERIOUS"] = "serious";
  ReportErrorLevel["FATAL"] = "fatal";
})(ReportErrorLevel || (ReportErrorLevel = {}));
;
export var ReportErrorType;
(function (ReportErrorType) {
  ReportErrorType["WECOM_SDK_ERROR"] = "WECOM_SDK_ERROR";
  ReportErrorType["API_RESP_ERROR"] = "API_RESP_ERROR";
  ReportErrorType["CODE_ERROR"] = "CODE_ERROR";
})(ReportErrorType || (ReportErrorType = {}));